import { useGetBeUser } from "@entities/auth/lib/hooks/useGetUser";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { AdminUser } from "@shared/lib/types";
import { useCallback } from "react";
import { ADMIN_LIST_QUERY_KEY } from "../constants/";
import { AdminService } from "../servcies/admin.service";

const QUERY_OPTIONS = {
  queryKey: ADMIN_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useUpdateAdmin() {

  const {beUser} = useGetBeUser();
  const updateAdmin = useCallback(
    ({ userId, data }: { userId: string; data: Partial<AdminUser> }) =>
      AdminService.updateAdmin(userId, data).catch(async (err) => {
        const responseBody = await err.response.json(); // Get the response body
        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<{ userId: string; data: Partial<AdminUser> }>({
    mutationFn: updateAdmin,
    options: QUERY_OPTIONS,
    onSuccess: (c, _, { userId }) => {
      ToastService.success("Employee Edited");
      c.invalidateQueries({ queryKey: [...ADMIN_LIST_QUERY_KEY, userId] });
      if (userId === beUser?._id) {
      c.invalidateQueries({queryKey: ["be-user"]});
      }
    },
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
